import React from 'react'
import {Modal} from 'react-bootstrap'
import {FaTimesCircle} from 'react-icons/fa'
import PrimaryButton from '../common/buttons/PrimaryButton'

interface RequiredSubscriptionModalProps {
  isOpen: boolean
  onClose: () => void
}

const RequiredSubscriptionModal: React.FC<RequiredSubscriptionModalProps> = ({isOpen, onClose}) => {
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FaTimesCircle className='text-danger me-2' />
          Subscription Required
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='mb-0'>
          Your subscription is <strong>cancelled</strong>. <br />
          Please subscribe to continue using the portal features.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <PrimaryButton
          color='secondary'
          onClick={() => {
            onClose() // close the main modal too
          }}
        >
          Close
        </PrimaryButton>
      </Modal.Footer>
    </Modal>
  )
}

export default RequiredSubscriptionModal
